import React, { createContext, useContext, FC, ReactNode } from 'react';

const StatusPillContext = createContext<boolean>(false);

export const StatusPillHiddenProvider: FC<{
  hidden: boolean;
  children: ReactNode;
}> = ({ hidden, children }) => (
  <StatusPillContext.Provider value={hidden}>
    {children}
  </StatusPillContext.Provider>
);

export const useStatusPillHidden = (): boolean => useContext(StatusPillContext);
